<div class="approw">
    <div class="row">
        <div class="col-lg-12">
            <div id="content-header" class="clearfix">
                <div class="pull-left">
                    <ol class="breadcrumb">
                        <li><a href="javascript:void(0)" (click)="$state.go('missioncontrol.dashboard', {}, {reload: true})">Home</a></li>
                        <li class="active"><span>Add New Candidates</span></li>
                    </ol>
                    <h1 class="heading-css">Add New Candidates</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12">
            <app-add-candidates (saveCallback)="saveCallback()" context="candidateScreen" sourceScreen="CANDIDATE"></app-add-candidates>
        </div>
    </div>
</div>
